import { Box, CircularProgress, LinearProgress, Typography, IconButton } from '@mui/material'
import React, { useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import BackupOutlinedIcon from "@mui/icons-material/BackupOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import { fileUpload } from '../../api/uploadApi';
import ValidationErrorText from '../common/ValidationErrorText';

export default function UploadFile({ label, value, acceptFile, acceptFileLabel, onChange, fieldError }) {
    const fileInputRef = useRef(null);
    const [fileName, setFileName] = useState("");
    const [fileSize, setFileSize] = useState(0);
    const [uploading, setUploading] = useState(false)
    const [progress, setProgress] = useState(0)
    const [error, setError] = useState("");

    const handleUpload = async (uploaded) => {
        if (!uploaded) return
        const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/png",
            "image/webp"
        ];

        if (!allowedTypes.includes(uploaded.type)) {
            setError("Only PDF or image files are allowed");
            return;
        }
        if (uploaded.size > 50 * 1024 * 1024) {
            setError("File size should be under 50MB")
            return
        }

        setError('')
        setUploading(true)
        setProgress(0)

        try {
            const data = await fileUpload(uploaded, prog => setProgress(prog))
            if (data.url) {
                onChange(data.url)
            } else {
                setError('File upload failed (no url returned)')
            }
        } catch {
            setError('File upload failed!')
        } finally {
            setUploading(false)
            setProgress(0)
        }
        if (fileInputRef.current) fileInputRef.current.value = ''
    }


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name);
            setFileSize(Math.round(file.size / 1024)); // KB
            handleUpload(file)
        }
    };

    const handleRemoveFile = () => {
        setFileName("");
        setFileSize(0);
        fileInputRef.current.value = null;
        onChange(null)
    };

    const handleBoxClick = () => {
        fileInputRef.current.click();
    };
    return (
        <Box
            sx={{
                width: "100%",
                border: "2px dashed #1075FF",
                borderRadius: "10px",
                p: 2,
                background: "#EDF4FF",
                position: "relative",
                mt: 2,
                cursor: "pointer", // show pointer on hover
            }}

            onClick={() => !uploading && handleBoxClick()} // trigger input click
        >
            <input
                type="file"
                accept={acceptFile ?? ".pdf,.png"}
                hidden
                ref={fileInputRef}
                onChange={handleFileChange}
                disabled={uploading}
            />
            <Box sx={{ display: "flex", gap: "12px", alignItems: "center", justifyContent: "center" }}>
                <BackupOutlinedIcon sx={{ color: "#1075FF", height: "40px", width: "40px" }} />
                <Box sx={{ textAlign: "center" }}>
                    <Button variant="outlined" component="label" sx={{ border: "none" }}>
                        {label}
                    </Button>
                    <Typography sx={{ fontSize: "14px" }}>{acceptFileLabel ?? 'Choose PDF/PNG File'}</Typography>

                    {(fileName || value) && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Typography sx={{ fontSize: "13px", fontWeight: 500, color: "#555" }}>
                               {fileName ? `Selected: ${fileName} (${fileSize} KB)` : `Receipt`}
                            </Typography>
                            <IconButton size="small" onClick={handleRemoveFile}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    )}

                    {uploading && <Box mt={2} mb={1} display="flex" alignItems="center" gap={2}>
                        <CircularProgress size={24} />
                        <Typography fontSize="14px">Uploading...</Typography>
                        <Box sx={{ width: '120px', mt: 1 }}>
                            <LinearProgress variant="determinate" value={progress} sx={{ height: 6, borderRadius: 5 }} />
                        </Box>
                    </Box>}
                </Box>
            </Box>
            <Box textAlign={"center"} display={"flex"}>
                <ValidationErrorText error={error || fieldError} />
            </Box>

        </Box>
    )
}
